<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
            <!-- //文本搜索内容 -->
            <div class="fun-panel fun-search-form-wrapper">
                <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                    <a-row :gutter="[0, 6]">
                        <a-col :span="6">
                            <a-form-item label="标题">
                                <a-input ref="bt" v-model="queryParams.bt" placeholder="" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="18">
                            <span class="fun-search-form-buttons" :style="{ float: 'right', overflow: 'hidden' }">
                                <a-button type="primary" @click="loadData" style="margin-right: 8px">查询</a-button>
                                <a-button @click="reset">重置</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
        </a-anchor>
        <div class="fun-panel">
            <a-spin :spinning="tableDataLoading">
                <vxe-toolbar
                    size="mini"
                    custom
                    :refresh="{
                        query: () => {
                            this.loadData();
                        }
                    }"
                >
                </vxe-toolbar>

                <vxe-table
                    ref="table"
                    size="mini"
                    resizable
                    row-id="id"
                    auto-resize
                    align="left"
                    :max-height="$FG_util.getTableHeightDirect(2)"
                    show-overflow="tooltip"
                    header-align="center"
                    :data="tableData"
                    highlight-hover-row
                    highlight-current-row
                    :sort-config="{
                        trigger: 'cell',
                        defaultSort: { field: sort.field, order: sort.order },
                        remote: true,
                        orders: ['asc', 'desc']
                    }"
                    @sort-change="handleSortChange"
                    @cell-dblclick="doubleClick"
                >
                    <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                    <vxe-table-column field="djzt" title="单据状态" width="80" align="center"></vxe-table-column>
                    <vxe-table-column field="bt" title="标题" width="200" header-align="center"></vxe-table-column>
                    <vxe-table-column field="fbt" title="副标题" width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="gjz" title="关键字" width="120" align="center"></vxe-table-column>
                    <vxe-table-column field="jsdwlx" title="接收单位类型" width="200" header-align="center"></vxe-table-column>
                    <vxe-table-column field="jsdws" title="接收单位" width="300" header-align="center"> </vxe-table-column>
                    <vxe-table-column field="yxqsrq" title="有效起始日期" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="yxjzrq" title="有效截止日期" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="lrr" title="录入人" width="100" align="center"> </vxe-table-column>
                    <vxe-table-column field="lrrq" title="录入日期" width="120" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="tjsj" title="提交时间" width="130" sortable align="center"> </vxe-table-column>
                    <vxe-table-column field="bz" title="备注" min-width="80"> </vxe-table-column>
                    <vxe-table-column title="操作" align="center" width="150">
                        <template v-slot="scope">
                            <span class="btn_edit" @click="look(scope.row)">查看</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <vxe-pager
                    background
                    size="mini"
                    :current-page.sync="pageinfo.pageNo"
                    :page-size.sync="pageinfo.pageSize"
                    :total="pageinfo.total"
                    :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
                    @page-change="handlePageChange"
                >
                </vxe-pager>
            </a-spin>
        </div>
    </div>
</template>

<script>
export default {
    name: "TzggcxBrowse",
    components: {},
    props: ["dataId", "submited", "componentName"],
    data() {
        return {
            tableData: [], //表格数据
            queryParams: { funid: "OA1002", dwbj: 1 },
            // 分页
            pageinfo: {
                pageNo: 1,
                pageSize: 20,
                total: 0
            },
            // 排序
            sort: {
                field: "tjsj",
                order: "desc"
            },
            tableDataLoading: false,
            btnPrimary: "primary",
            btnDefault: "default",
            isShow: false
        };
    },
    computed: {
        formIsVisible: {
            get() {
                return this.componentName;
            },
            set(newVal) {
                this.$emit("update:componentName", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        }
    },
    activated() {
        this.loadData(this.editDataId);
    },
    methods: {
        //双击事件
        doubleClick({ row }) {
            this.look(row);
        },
        //点击页码
        handlePageChange({ currentPage, pageSize }) {
            this.pageinfo.pageNo = currentPage;
            this.pageinfo.pageSize = pageSize;
            this.loadData();
        },
        //点击表头排序
        handleSortChange({ property, order }) {
            this.sort.field = property;
            this.sort.order = order;
            this.loadData();
        },
        //查询列表数据
        loadData(id) {
            // 如果没有指定选中记录则选中刷新前选中的记录
            if (!id) {
                let row = this.$refs.table.getCurrentRecord();
                if (row) {
                    id = row.id;
                }
            }
            this.tableDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/oagl/tzgl/list",
                    {
                        funid: "OA1002",
                        menuid: "0E375EB9-7740-4E47-990A-D6626251B517",
                        defaulttablename: "OA_TZGG",
                        pageNo: this.pageinfo.pageNo,
                        pageSize: this.pageinfo.pageSize,
                        queryParams: this.queryParams,
                        sort: this.sort
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        this.tableData = data.data;
                        // 需要设置当前页，因为查询可能导致当前页发生变化
                        this.pageinfo.pageNo = data.pageinfo.pagenum;
                        this.pageinfo.total = data.pageinfo.maxrow;
                    } else {
                        // 数据加载失败清空表格
                        this.tableData = [];
                    }
                })
                .then(() => {
                    this.$nextTick(() => {
                        let row = null;
                        // 获取之前选择的记录
                        if (id) {
                            row = this.$refs.table.getRowById(id);
                        }
                        // 如果之前没有选择记录且表格不为空则选择第一条记录
                        if (!row && this.tableData.length > 0) {
                            row = this.$refs.table.getRowById(this.tableData[0].id);
                        }
                        if (row) {
                            // 设置当前记录
                            this.$refs.table.setCurrentRow(row);
                        } else {
                            // 清空当前行
                            this.$refs.table.clearCurrentRow();
                        }
                    });
                });
        },
        //重置文本内容
        reset() {
            this.queryParams = {};
        },
        // 查看
        look(row) {
            // 设置编辑记录id
            this.editDataId = row.id;
            this.formIsVisible = "TzggcxForm";
        }
    }
};
</script>
